const UsersList = () =>
	import(/* webpackChunkName: "userslist"*/ "@/views/UsersList/index.vue");

const UsersCreateSuperAdmin = () =>
	import(
		/* webpackChunkName: "userscreatesuperadmin" */ "@/views/User/Create/SuperAdmin.vue"
	);
const UsersCreateAccessCustomer = () =>
	import(
		/* webpackChunkName: "userscreateaccesscustomer" */ "@/views/User/Create/Organisation.vue"
	);
const UsersCreateHospital = () =>
	import(
		/* webpackChunkName: "userscreatehospital" */ "@/views/User/Create/Hospital.vue"
	);
const UsersCreateDailydata = () =>
	import(
		/* webpackChunkName: "userscreatehospital" */ "@/views/User/Create/DailyData.vue"
	);

const UserDashboard = () =>
	import(/* webpackChunkName: "userview"*/ "@/views/User/index.vue");

const UserEdit = () =>
	import(/* webpackChunkName: "useredit"*/ "@/views/User/Edit/index.vue");

const OrganisationUserEdit = () =>
	import(
		/* webpackChunkName: "organisationuseredit"*/ "@/views/User/Edit/Organisation.vue"
	);

const OrganisationUserView = () =>
	import(
		/* webpackChunkName: "organisationuserview"*/ "@/views/User/View/Organisation.vue"
	);
const HospitalUserView = () =>
	import(
		/* webpackChunkName: "hospitaluserview"*/ "@/views/User/View/Hospital.vue"
	);

const HospitalUserEdit = () =>
	import(
		/* webpackChunkName: "hospitaluseredit"*/ "@/views/User/Edit/Hospital.vue"
	);
const DataUserEdit = () =>
	import(
		/* webpackChunkName: "hospitaluseredit"*/ "@/views/User/Edit/DailyData.vue"
	);

export default [
	{
		path: "users",
		name: "Users",
		component: UsersList,
		meta: {
			title: "DailyAdmin - Users list"
		}
	},
	{
		path: "users/:listName",
		name: "UsersListView",
		component: UsersList,
		props: true,
		meta: {
			title: "DailyAdmin - Users list"
		}
	},
	{
		path: "user/create/super",
		name: "UsersCreateSuper",
		component: UsersCreateSuperAdmin,
		meta: {
			title: "DailyAdmin - Create super user"
		}
	},
	{
		path: "user/create/publisher",
		name: "UsersCreateAccessCustomer",
		component: UsersCreateAccessCustomer,
		meta: {
			title: "DailyAdmin - Create publisher user"
		}
	},
	{
		path: "user/create/hospital",
		name: "UsersCreateHospital",
		component: UsersCreateHospital,
		meta: {
			title: "DailyAdmin - Create hospital user"
		}
	},
	{
		path: "user/create/dailydata",
		name: "UsersCreateDailydata",
		component: UsersCreateDailydata,
		meta: {
			title: "DailyAdmin - Create data user"
		}
	},
	{
		path: "user/:userid/edit",
		name: "UserEdit",
		component: UserEdit,
		props: true,
		meta: {
			title: "DailyAdmin - User edit"
		}
	},
	{
		path: "user/:userid/edit/publisher",
		name: "OrganisationUserEdit",
		component: OrganisationUserEdit,
		props: true,
		meta: {
			title: "DailyAdmin - Publisher user edit"
		}
	},
	{
		path: "user/:userid/publisher",
		name: "OrganisationUserView",
		component: OrganisationUserView,
		props: true,
		meta: {
			title: "DailyAdmin - Publisher user edit"
		}
	},

	{
		path: "user/:userid/edit/connect",
		name: "HospitalUserEdit",
		component: HospitalUserEdit,
		props: true,
		meta: {
			title: "DailyAdmin - Connect user edit"
		}
	},
	{
		path: "user/:userid/hospital",
		name: "HospitalUserView",
		component: HospitalUserView,
		props: true,
		meta: {
			title: "DailyAdmin - Publisher user edit"
		}
	},
	{
		path: "user/:userid/edit/data",
		name: "DataUserEdit",
		component: DataUserEdit,
		props: true,
		meta: {
			title: "DailyAdmin - DailyData user edit"
		}
	},
	{
		path: "user/:userid",
		component: UserDashboard,
		name: "UserDashboard",
		props: true,
		meta: {
			title: "DailyAdmin - User view"
		}
	}
];
